import { styled } from 'styled-components';
import type { CollapsibleContentProps as RadixCollapsibleContentProps } from '@radix-ui/react-collapsible';
import { Content } from '@radix-ui/react-collapsible';
import { isNotUndefined } from '@wistia/type-guards';

const ClampedContent = styled.div<{
  $clamp: number;
}>`
  --wui-collapsible-content-clamp-lines: ${({ $clamp }) => $clamp};
`;

export type CollapsibleContentProps = {
  /**
   * The number of lines to clamp the content to when `Collapsible` is closed.
   */
  clamp?: number;
  /**
   * The content that will be hidden when `Collapsible` is closed.
   */
  children: RadixCollapsibleContentProps['children'];
};

export const CollapsibleContent = ({ clamp, children }: CollapsibleContentProps) => {
  if (isNotUndefined(clamp)) {
    return (
      <ClampedContent
        $clamp={clamp}
        data-wui-collapsible-content="true"
      >
        {children}
      </ClampedContent>
    );
  }

  return (
    <Content>
      <>{children} </>
    </Content>
  );
};
